import { useEffect, useState } from "react";
import styles from "./Usuarios.module.css";
import { Link } from "react-router-dom";
//import axios from "axios";
import load from "../../../../Images/loading.gif";

function Usuarios() {
    const [users, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await fetch("https://eclipsebots.com/api/users/get", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: "include"
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch users");
                }

                const data = await response.json();

                setUsuarios(data);
            } catch (error) {
                console.error("Erro ao buscar usuários:", error);
                setUsuarios([]);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    const filteredUsers = users.filter(user =>
        user.username.toLowerCase().includes(search.toLowerCase()) ||
        user.id.includes(search)
    );

    return (
        <div className={styles.users}>
            <div className={styles.title}>Usuários</div>
            {users.length === 0 ? (
                <div className={styles.noData}>
                    Não existe nenhum usuário de momento.
                </div>
            ) : (
                <div className={styles.usercontent}>
                    <input
                        type="text"
                        placeholder="Procurar por nome de usuário..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className={styles.searchInput}
                    />
                    {filteredUsers.length === 0 && (
                        <div className={styles.noData}>
                            Não existe nenhum usuário com esses dados.
                        </div>
                    )}
                    <div className={styles.overflow}>
                        {filteredUsers.map((user, index) => {
                            const isFirst = index === 0;
                            const isLast = index === users.length - 1;

                            return (
                                <Link to={`${user.id}`}>
                                    <div key={user.id} className={`${styles.user} ${isFirst ? styles.first : ""} ${isLast ? styles.last : ""}`}>
                                        <div className={styles.image}>
                                            <img src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${user.avatar.startsWith("a_") ? "gif" : "png"}`} alt="Imagem de Perfil" nError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = "https://i.imgur.com/bWhx7OT.png";
                                            }} />
                                        </div>
                                        <div className={`${styles.name} ${styles.imagem}`}>
                                            {user.username}
                                        </div>
                                    </div>
                                </Link>
                            )
                        })}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Usuarios;